import { rootRoute } from './__root';
import { authLayoutRoute } from './layouts/auth-layout-route';
import { dashboardLayoutComponent } from './layouts/dashboard-layout-route';
import { loginRedirectRoute, loginRoute } from './auth/login-route';
import * as profileRoutes from './protected/profile-route';
import { protectedRoute } from './protected/protected-route';
import { usersRoute, detailUsersRoute } from './protected/users-route';
import { transactionsRoute, detailTransactionsRoute } from './protected/transactions-route';
import {
  complaintRoute,
  detailComplaintRoute,
  createComplaintRoute,
} from './protected/complaint-route';
import { withdrawalRoute, detailWithdrawalRoute } from './protected/withdrawal-route';
import { kycRoute } from './protected/kyc-route';
import { manualTransferRoute, detailManualTransferRoute } from './protected/manual-transfer-route';

import { indexRoute } from '.';

export const routeTree = rootRoute.addChildren([
  indexRoute,
  authLayoutRoute.addChildren([loginRoute, loginRedirectRoute]),

  protectedRoute.addChildren([
    dashboardLayoutComponent.addChildren([
      ...Object.values(profileRoutes),
      usersRoute.addChildren([detailUsersRoute]),
      transactionsRoute.addChildren([detailTransactionsRoute]),
      withdrawalRoute.addChildren([detailWithdrawalRoute]),
      complaintRoute.addChildren([createComplaintRoute, detailComplaintRoute]),
      kycRoute,
      manualTransferRoute.addChildren([detailManualTransferRoute]),
    ]),
  ]),
]);
